// import React from 'react';
// import styles from "../HeaderBar/HeaderBar.module.css";
// import { useNavigate } from 'react-router-dom';
// const HeaderBar = ({ title, subtitle,bottomSubtitle, dropdownOptions = [], onDropdownChange,selectedAgent, backgroundColor = "#fff", color = '#24252C' }) => {
//   const navigate = useNavigate();
//   const handleBack = () => {
//     const currentPath = window.location.pathname;

//     if (currentPath.endsWith("/plan") || currentPath === "/plan" || currentPath=="/assign-number") {
//       navigate("/dashboard");
//     }else if (currentPath.endsWith("/plans") || currentPath === "/plans") {
//       navigate("/steps");} 
//     else {
//       navigate(-1);
//     }
//   };
//   return (
//     <div className={styles.headerMain} style={{ backgroundColor }}>
//       <div className={styles.BothFlex}>
//         <div className={styles.backIcon}>
//           <img src='svg/Back-icon.svg' alt='Back-icon' onClick={handleBack} />
//         </div>

//         <div className={styles.titleWrapper}>
//           <div className={styles.title}>
//             {subtitle && <h6>{subtitle}</h6>}
//             <h2 style={{ color }}>{title}</h2 >
//           </div>

//           {dropdownOptions.length > 0 && (
//             <select
//             value={selectedAgent}
//               className={styles.dropdown}
//               onChange={(e) => onDropdownChange?.(e.target.value)}
//             >
//               {dropdownOptions.map((option, idx) => (
//                 <option key={idx} value={option}>
//                   {option}
//                 </option>
//               ))}
//             </select>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeaderBar;




import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import styles from "../HeaderBar/HeaderBar.module.css";
import { useNavigate } from 'react-router-dom';
import { safeBackPath } from '../../utils/safeBackPath';
/*
 * lottie.host se liya gaya "Profile Material Icon", local copy ke saath teen
 * badlaav: (1) badge ka gradient red (#cc0725 → #ffb8c3) se purple
 * (#6524EB → #AC46FC) kar diya; (2) peeche wali pale "Shape Layer 1" hata di,
 * ab background transparent hai aur icon header ke apne rang pe baithta hai;
 * (3) "Files" layer ka scale 65% → 104.5%, taaki purple circle 1000px canvas
 * ko bhar de — 65% pe wo sirf 62% ghera tha, yaani 50px box me ~31px ka icon
 * aur chaaro taraf khaali jagah; (4) iframe embed ki jagah bundled JSON — har mount pe ek
 * cross-origin iframe + network round-trip mehnga tha, aur iframe ke andar CSS
 * na pahunchne ki wajah se rang badalna waise bhi mumkin nahi tha.
 */
import profileAvatarAnim from './profile-avatar.json';

// Swipe ke pehle half (purana text bahar jaana) ki length. HeaderBar.module.css
// ke `.title h2` transition se EXACT match honi chahiye — JS text tab badalta
// hai jab CSS ne use poora bahar nikaal diya ho. Kam kar diya to purana text
// badalte hue pakda jaayega. Aane wale half ki timing sirf CSS me hai
// (.titleIn ka keyframe), usse JS ka koi lena-dena nahi.
const TITLE_FADE_MS = 280;
const HeaderBar = ({
  title,
  subtitle,
  bottomSubtitle,
  dropdownOptions = [],
  onDropdownChange,
  selectedAgent,
  backgroundColor = "#fff",
  color = '#24252C',
  rightIcon,
  hideBackButton = false,
  /*
   * Opt-in override for the back arrow's destination.
   *
   * Without it handleBack() below picks by CURRENT PATH, which cannot know
   * where the user came from: /plan is reachable from the Dashboard agent menu
   * AND from Agent Details, but always went back to /fast-agent-detail — so a
   * multi-agent user pressing Back from Upgrade Plan landed on some agent's
   * page instead of the Dashboard they started on. Callers that know the
   * origin (they already pass it as `locationPath` in router state) can hand it
   * over here. Validated by safeBackPath, since an unroutable value renders a
   * blank screen — App.js has no catch-all route. Unset → unchanged behaviour.
   */
  backTo = "",
  // New opt-in props for the profile-icon variant. When showProfileIcon
  // is true, the leading back-arrow is replaced with a circular profile
  // picture (or the default profile-icon.svg fallback) that links to
  // /edit-profile. Falls back to the standard back-icon behavior so
  // existing screens are unchanged.
  showProfileIcon = false,
  profileImg = "",
  /*
   * Title ko chhota karke wrap hone deta hai. Default h2 nowrap + ellipsis pe
   * chalta hai (chhoti header width me lamba naam icons pe chadh jaata tha) —
   * par wahi rule ek poore vaakya ko "Please compl…" bana deta hai. Jo callers
   * title me sentence bhejte hain (jaise profile-complete nudge) wo ise on
   * kar dein. Baaki screens pe kuch nahi badalta.
   */
  compactTitle = false,
  /*
   * Title ke aage ek chevron (>) dikhata hai — "ye line tap karne layak hai"
   * ka ishara. Boolean rakha hai, node nahi: title-crossfade neeche purani
   * aur nayi value ko === se compare karta hai, aur JSX har render pe naya
   * object hota — comparison hamesha fail hoti aur swap loop me chala jaata.
   */
  titleArrow = false,
  /*
   * Opt-in: back arrow ka apna handler. Jin screens ka back andar ke views
   * ke beech chalta hai (jaise PublicAgentAvailability: sub-view → overview)
   * wo ise dete hain. Unset → neeche wala handleBack, pehle jaisa.
   */
  onBack,
}) => {
  const navigate = useNavigate();

  /*
   * Profile-image robustness.
   *
   * Reported bug: "Google profile pic disappears after some time"
   * (user-facing string: "udd rahi h"). Two real root causes, neither
   * of which was solved by the earlier zustand-store fixes:
   *
   *   1. **Google CDN Referer 403.** Google's avatar host
   *      (lh3.googleusercontent.com) rejects image GETs with a
   *      `Referer` header pointing at a domain that isn't whitelisted
   *      on the OAuth client. Browsers default to
   *      strict-origin-when-cross-origin, so localhost / app.rxpt.ai
   *      gets a 403 the second time the browser revalidates the
   *      image cache — first paint works (cached or skipped Referer),
   *      then the avatar "disappears" when revalidation 403s.
   *      Fix: `referrerPolicy="no-referrer"` tells the browser NOT
   *      to send Referer at all, and the CDN serves the image.
   *
   *   2. **onError mutating DOM behind React's back.** The old
   *      `onError={(e) => e.target.src = "/svg/profile-icon.svg"}`
   *      changed the DOM directly. React still thinks the src is the
   *      Google URL, so on the next re-render it reconciles back to
   *      the broken URL → onError fires AGAIN → falls back → ...
   *      The result is a visible flicker on every render and the
   *      eventual permanent fallback because the cycle never
   *      stabilises.
   *      Fix: use React state for the fallback flag. When the image
   *      fails we mark it failed and render the default icon
   *      explicitly. profileImg prop changes reset the failed state
   *      so a fresh URL gets a fresh try.
   */
  const [imgFailed, setImgFailed] = useState(false);
  useEffect(() => {
    setImgFailed(false);
  }, [profileImg]);
  const effectiveProfileSrc = profileImg && !imgFailed ? profileImg : "";

  /*
   * Title ka smooth slide-swap.
   *
   * FastAgentDetails har 4 second pe title ko naam <-> "Update Profile" swap
   * karta hai. Seedha prop badalne se text ek hi frame me badal jaata hai —
   * jhatka dikhta hai. Yahan swap do half me hota hai: purana text baayein
   * sarak kar gayab (.titleFading), phir naya text daayein se aakar apni
   * jagah pe rukta hai (.titleIn ka keyframe).
   *
   * Isliye `display` prop se ek step peeche chalta hai — fade-out ke doran
   * purana text hi dikhta rehta hai. Teeno cheezein (text, compact, arrow) ek
   * saath badalti hain: alag-alag badlein to purane text pe naye state ka
   * wrap/arrow lag jaata aur ek frame ka reflow saaf dikhta.
   *
   * `swap` counter h2 ki key hai. Enter ke liye transition kaam nahi karti
   * (naya node apni final state me mount hota hai, browser ke paas start
   * state hoti hi nahi), isliye keyframe chahiye — aur keyframe dobara tabhi
   * chalta hai jab node remount ho. swap > 0 ka check isliye hai ki pehle
   * mount pe animation na chale: jo screens title kabhi nahi badaltin, unhe
   * page khulte hi bewajah slide nahi dikhna chahiye.
   */
  const [display, setDisplay] = useState({
    title,
    compact: compactTitle,
    arrow: titleArrow,
  });
  const [titleVisible, setTitleVisible] = useState(true);
  const [swap, setSwap] = useState(0);
  useEffect(() => {
    if (
      title === display.title &&
      compactTitle === display.compact &&
      titleArrow === display.arrow
    ) {
      return;
    }
    setTitleVisible(false);
    const t = setTimeout(() => {
      setDisplay({ title, compact: compactTitle, arrow: titleArrow });
      setSwap((n) => n + 1);
      setTitleVisible(true);
    }, TITLE_FADE_MS);
    return () => clearTimeout(t);
  }, [title, compactTitle, titleArrow, display]);

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }
    const currentPath = window.location.pathname;

    // Caller told us where the user came from — trust it over the path rules
    // below (but never blindly: safeBackPath rejects anything unroutable, and
    // `avoid` stops it pointing back at the screen we're already on).
    if (backTo) {
      navigate(safeBackPath(backTo, { avoid: currentPath }));
      return;
    }

    if (currentPath.endsWith("/plan") || currentPath === "/plan" || currentPath=="/assign-number"||currentPath=="/fast-agent-detail") {
      navigate("/fast-agent-detail");
    }else if (currentPath.endsWith("/plans") || currentPath === "/plans") {
      navigate("/steps");}
    else {
      navigate(-1);
    }
  };

  const handleProfileClick = () => {
    // Pass the current path as returnTo so EditProfile's back action
    // lands the user back where they came from (e.g.
    // /fast-agent-detail) instead of always the dashboard.
    const returnTo =
      typeof window !== "undefined" ? window.location.pathname : "/fast-agent-detail";
    navigate("/edit-profile", { state: { returnTo } });
  };

  /*
   * Profile variant me poora greeting block ek hi tap target hai — avatar,
   * "Hello!", naam/nudge aur chevron. Pehle sirf 50px ka avatar clickable tha;
   * "Update Profile" jaise call-to-action pe tap karna kuch karta hi nahi tha.
   *
   * Handler .BothFlex pe hai (avatar aur title dono ka parent), isliye beech
   * ka 10px gap bhi tap ho jaata hai — dono par alag-alag handler lagane se wo
   * gap dead rehta.
   *
   * tabIndex/onKeyDown bhi: pehle role="button" to tha par focusable nahi, to
   * keyboard se profile khulta hi nahi tha.
   */
  const profileTapProps = showProfileIcon
    ? {
        className: `${styles.BothFlex} ${styles.profileTapArea}`,
        onClick: handleProfileClick,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            // Space page ko scroll kar deta hai — button jaisa behave karna hai.
            e.preventDefault();
            handleProfileClick();
          }
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Open profile",
      }
    : { className: styles.BothFlex };

  return (
    <div
      className={`${styles.headerMain} ${showProfileIcon ? styles.profileHeader : ""}`}
      style={{ backgroundColor }}
    >
      <div {...profileTapProps}>
        {hideBackButton ? null : showProfileIcon ? (
          // Profile-icon variant — circular avatar in place of the back
          // arrow. Uses the user's profilePicture when present, falls
          // back to the default SVG icon. Click parent (.profileTapArea) pe
          // hai, yahan dobara lagane ki zaroorat nahi.
          <div className={styles.backIcon}>
            {effectiveProfileSrc ? (
              <img
                src={effectiveProfileSrc}
                alt="Profile"
              // referrerPolicy: stops the browser from sending the
              // `Referer` header to Google's CDN, which avoids the
              // 403s that caused the avatar to "disappear" after a
              // few seconds. Safe for our own /uploads/ avatars too —
              // those don't check Referer.
              referrerPolicy="no-referrer"
              // Do not force anonymous CORS: Google avatar responses do not
              // always include ACAO, even though normal image loads work.
                onError={() => {
                // State-based fallback (NOT e.target.src mutation) so
                // React reconciles cleanly and doesn't try to repaint
                // the broken URL on every re-render.
                if (!imgFailed) setImgFailed(true);
                }}
                style={{
                  width: 50,
                  height: 50,
                  // block: inline img ke neeche baseline ka gap rehta hai, jo
                  // wrapper ko 50px se lamba kar deta — ring gol nahi rehti.
                  display: "block",
                  borderRadius: "50%",
                  objectFit: "cover",
                  objectPosition: "center top",
                  border: "1px solid #E0E5F2",
                }}
              />
            ) : (
              // Default avatar ab static SVG ki jagah Lottie animation hai.
              // pointerEvents:none se click parent div tak jaata hai (warna
              // /edit-profile navigation swallow ho jaata hai).
              <Lottie
                animationData={profileAvatarAnim}
                loop
                autoplay
                aria-hidden="true"
                style={{
                  width: 50,
                  height: 50,
                  display: "block",
                  pointerEvents: "none",
                }}
              />
            )}
          </div>
        ) : (
          <div className={styles.backIcon}>
            {/* Leading slash zaroori hai: relative path nested route pe
                /rewards/svg/Back-icon.svg ban jaata tha aur icon 404 ho jaata.
                Top-level routes pe resolution pehle jaisi hi rehti hai. */}
            <img src='/svg/Back-icon.svg' alt='Back-icon' onClick={handleBack} />
          </div>
        )}

        <div
          className={`${styles.titleWrapper} ${dropdownOptions.length > 0 ? styles.withDropdown : ""}`}
        >
          <div className={styles.title}>
            {subtitle && <h6 className={styles.subtitleH6} >{subtitle}</h6>}
            <h2
              key={swap}
              className={[
                display.compact ? styles.titleCompact : "",
                titleVisible ? "" : styles.titleFading,
                swap > 0 ? styles.titleIn : "",
              ].filter(Boolean).join(" ")}
              style={{ color }}
            >
              {display.title}
              {display.arrow && (
                // currentColor — arrow ko title ka hi rang mile, chahe caller
                // `color` prop se kuch bhi bheje.
                <svg
                  className={styles.titleArrowIcon}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M9 5l7 7-7 7"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </h2 >
            {/* <h5>{bottomSubtitle}</h5> */}
          </div>

          {dropdownOptions.length > 0 && (
            <select
            value={selectedAgent}
              className={styles.dropdown}
              onChange={(e) => onDropdownChange?.(e.target.value)}
            >
              {dropdownOptions.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))}
            </select>
          )}
        </div>
        {/* RIGHT (OPTIONAL ICON) */}
        {rightIcon && (
          <div
            className={styles.rightIcon}
            /*
             * rightIcon bhi .BothFlex ke andar hai, aur profile variant me us
             * poore box pe /edit-profile ka click lagta hai. Bina iske ek
             * rightIcon pe tap karne se profile bhi khul jaata. Icon ka apna
             * handler pehle chalta hai, bubbling yahan rukti hai.
             */
            onClick={(e) => e.stopPropagation()}
          >
            {rightIcon}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderBar;

